// extracted by mini-css-extract-plugin
export default {"component":"b1ERGP","branded":"c1ERGP","takeover":"d1ERGP","ghost":"e1ERGP"};